import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { BaseResponse } from './base-response';
import { EssentialService } from './essential.service';

@Injectable({
  providedIn: 'root'
})
export class CoreMenuService {

  getSlugData:any = JSON.stringify(localStorage.getItem('slugData'));
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private essentialsService: EssentialService
  ) { }
  private coreMenuSubject = new BehaviorSubject<BaseResponse<any>>(null);
  coreMenu$: Observable<BaseResponse<any>> = this.coreMenuSubject.asObservable();

  public getCoreMenus() {
    const refreshToken = JSON.parse(localStorage.getItem('coreRefreshToken'));
    const token = JSON.parse(localStorage.getItem('coreToken'));
    const username = localStorage.getItem('adUsername');

    let getCoreMenusParams = {
      Username: username,
      ComId: 1,
      AuthToken: token,
      RefreshToken: refreshToken
    };

    return this.authorizedMenuGetter(getCoreMenusParams)
      .pipe(
        tap((res) => res && this.coreMenuSubject.next(res)),
        catchError(err => {
          if (err.status == 401) {
            let req = { Token: token, RefreshToken: refreshToken };
            this.refreshTokenGetter(req)
              .subscribe(
                () => {
                  debugger;
                  setTimeout(() => {
                    debugger;
                    this.getCoreMenus().subscribe()
                  }, 1000)

                }
              )
          } else {
            return throwError(err)
          }
        })
      )

  }

  authorizedMenuGetter(params) {
    return this.http.post<BaseResponse<any>>(`/EskaCoreIntegrationApi/GetAuthorizedMenus`, params)
      .pipe(
        tap(() => console.log('started ...'))
      )
  }

  refreshTokenGetter(req) {
    return this.http.post<BaseResponse<any>>(`/EskaCoreIntegrationApi/RefreshToken`, req)
      .pipe(
        tap(() => console.log('refresh token started ...')),
        tap((res) => {
          if (res) {
            localStorage.setItem('coreToken', res.content.token);
            localStorage.setItem('coreRefreshToken', res.content.refreshToken);
          }
        })
      )
  }


  menuData = {};

  getMenu(id, data, slug) {
    const menuIndex = Object.keys(this.menuData).indexOf(id.toString());
    if (menuIndex === -1) {
      this.essentialsService.getCategoryMenus(id)
        .pipe(map((res: any) => res.result))
        .subscribe((res: any) => {
          Object.assign(this.menuData, {
            [id]: {
              activeLinkId: 0,
              activeLinkParents: [],
              activelinkRootLink: [],
              flatMenu: []
            }
          });
          this.buildMenu(id, res, slug)
        });
    }
  }

  buildMenu(id, menu, slug) {
    this.menuData[id].flatMenu = [];
    this.flattenMenu(id, menu);
    this.menuData[id].flatMenu = this.menuData[id].flatMenu.sort(sortByOrder);
    this.setActiveLink(id, slug);
  }

  flattenMenu(id, menu) {
    const m = [...menu];

    for (const item of m) {
      const { childs } = item;
      this.menuData[id].flatMenu.push(item);
      if (childs && childs.length > 0) { this.flattenMenu(id, childs); }
    }
  }

  setActiveLink(id, slug) {
    if (id) {

      if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
      const total = this.menuData[id].flatMenu
        .filter(item => (item.menuType === 2 || item.menuType === 6 ||item.menuType === 4 || item.menuType === 7  ) && item.slug === slug);

      if (total.length === 0) { return; }

      this.menuData[id].activeLinkParents = [];
      this.menuData[id].activelinkRootLink = [];

      // if (total.length > 1) {
      this.menuData[id].activeLinkId = total[total.length - 1].id;
      this.menuData[id].activeLinkParents.push(total[total.length - 1].id);
      this.setLinkParents(id, this.menuData[id].activeLinkId);
      // }
    }

  }

  setLinkParents(id, activeLinkId: number) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    const targetLink = this.menuData[id].flatMenu.find(link => link.id === activeLinkId);
    if (!targetLink) { return; }

    if (targetLink.parentId) {
      this.menuData[id].activeLinkParents.push(targetLink.parentId);
      this.setLinkParents(id, targetLink.parentId);
    }
    else {
      this.menuData[id].activelinkRootLink.push(targetLink)
    }
  }

  getActiveLink(id) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1 || !this.menuData[id].activeLinkId) { return; }
    return this.menuData[id].flatMenu.filter(x => x.id === this.menuData[id].activeLinkId);
  }

  getParentLink(id, parentId) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(x => x.id === parentId);
  }

  getActiveLinkChildren(id: number, parentId) {
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(x => x.parentId === parentId);
  }

  getActiveLinkSiblings(id: number) {
    if (!id || this.menuData[id].flatMenu.length == 0) { return []; }
    const activeLink = this.menuData[id].flatMenu.find(x => x.id === this.menuData[id].activeLinkId);
    return this.menuData[id].flatMenu.filter(x => x.parentId === activeLink.parentId);
  }

  isActiveChild(id, linkId: number) {
    if(!id) { return; }
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    const activeChild = this.menuData[id].flatMenu.find(item =>
      (item.menuType === 2 || item.menuType === 6 ||item.menuType === 4 || item.menuType === 7) && item.slug === this.getSlugData.slug && item.id === linkId && item.parentId !== null);

    if (!activeChild) { return; }
    return activeChild.id === linkId;
  }

  isHaveChildren(id, linkId: number) {
    if(!id) { return; }
    if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
    return this.menuData[id].flatMenu.filter(link => link.parentId === linkId).length > 0;
  }

  navigateToSection(el) {
    var elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }

  getRootMenu(id) {
    if (id) {
      if (Object.keys(this.menuData).indexOf(id.toString()) === -1) { return; }
      return this.menuData[id].flatMenu.filter(i => !i.parentId);
    }

  }

  public navigateTo(slug, el) {
    if (!el) {
      this.router.navigate([slug]);
    }
    if (el && slug) {
      this.router.navigate([slug]);
      setTimeout(() => {
        const elmnt = document.getElementById(el);
        if (elmnt && elmnt != null) {
          elmnt.scrollIntoView();
        }
      }, 200);
    }

  }

  isMenuReady(id) { return Object.keys(this.menuData).indexOf(id.toString()) >= 0; }

}



function sortByOrder(a: any, b: any) {
  return a['order'] - b['order']
}
